<template>
  <vue100vh style="position: fixed; width: 100%; overflow-y: hidden !important;">
    <v-app id="inspire" style="background: #fff; overflow-y: hidden !important;">
      <v-card flat class="hidden-md-and-up" style="padding:0 !important; width: 100%;" >
        <v-container fluid style="padding:0 !important;">
          <v-layout row>
            <div style="width: 100vw;">
              <!-- <v-toolbar style="background-color: #2562af !important;">
                <v-toolbar-title class="ml-0 pl-0"></v-toolbar-title>
                <img src="/static/img/icons/logoonechat_full-white.png" style="height: 45px; border-radius: 10px;margin-left: 4vw;cursor: pointer;" @click="toPage('/homepage')">
                <v-spacer></v-spacer>
                <v-badge color="red" overlap v-model="show_alert" v-if="num_listalert != 0">
                  <span slot="badge" v-if="num_listalert < 100">{{num_listalert}}</span>
                  <span slot="badge" v-else>99+</span>
                  <v-menu offset-x>
                    <v-btn slot="activator" flat fab medium>
                      <v-icon style="color: white;">mdi-bell-ring-outline</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile v-for="item in list_alert" :key="item.announce_id" style="width: 140px !important;">
                        <v-list-tile-title v-if="item.state == 'true'" @click="dialog_alert(item)">
                          <v-icon>mdi-bell-ring-outline</v-icon>
                          <span class="text-span">{{ item.message }}</span>
                        </v-list-tile-title>
                        <v-list-tile-title v-else-if="item.state == 'false'">
                          <v-icon style="color: #aeb5bb !important;">mdi-bell-off-outline</v-icon>
                          <span class="text-span-dis">{{ item.message }}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-badge>
                <v-menu offset-x v-else>
                  <v-btn slot="activator" flat fab medium>
                    <v-icon style="color: white;">mdi-bell-ring-outline</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="item in list_alert" :key="item.announce_id" style="width: 140px !important;">
                      <v-list-tile-title v-if="item.state == 'true'" @click="dialog_alert(item)">
                        <v-icon>mdi-bell-ring-outline</v-icon>
                        <span class="text-span">{{ item.message }}</span>
                      </v-list-tile-title>
                      <v-list-tile-title v-else-if="item.state == 'false'">
                        <v-icon style="color: #aeb5bb !important;">mdi-bell-off-outline</v-icon>
                        <span class="text-span-dis">{{ item.message }}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <div>
                  <v-menu bottom offset-y :close-on-content-click="false">
                    <v-avatar size="40px" slot="activator">
                      <img v-if="profilepicture != ''" :src="profilepicture" class="alligator-turtle" style="cursor: pointer;">
                      <img v-else-if="typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="cursor: pointer;">
                      <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="cursor: pointer;">
                    </v-avatar>
                    <v-list>
                      <v-list-tile @click="openQRcode()">
                        <v-icon meduim style="color: #2562af !important;">fas fa-qrcode</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">QR code</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-for="(item, index) in listmenu" @click="toPage(item.dialog)">
                        <v-icon meduim style="color: #2562af !important;">{{item.icon}}</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="logout()">
                        <v-icon meduim style="color: #2562af !important;">lock_open</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ออกจากระบบ</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </v-toolbar> -->
            </div>
          </v-layout>
        </v-container>
      </v-card>
      <v-content class="hidden-md-and-up" style="background-color: #fff !important; overflow-y: hidden !important;">
        <v-layout row wrap>
          <v-flex xs12 sm12 style="height: calc(100vh - 64px) !important; overflow-y: hidden !important;">
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-content>
      <Download :dilogDownload="dilogDownload"/>
      <Qrcodeuser :dialogShowQRCode="dialogShowQRCode" @closeShowQRCodeUser="closeShowQRCodeUser"></Qrcodeuser>
      <AgoraCallDialog :AgoraCallDialog="AgoraCallDialog" :AgoraOption="AgoraOption" :infor_call="infor_call" :tokenuser="token" @decline_call="decline_call" @closeAgoraDialog="closeAgoraDialog"></AgoraCallDialog>
      <checkconsentOnechatDialog :url_consent="url_consent" :consentOnechatDialog="consentOnechatDialog" @closeDialogConsentOnechat="closeDialogConsentOnechat"></checkconsentOnechatDialog>
      <newConsent :newConsentDialog="newConsentDialog" :newConsentDetail="newConsentDetail" @closeNewConsent="closeNewConsent"/>

    </v-app>
  </vue100vh>
</template>

<script>
import checkconsentOnechatDialog from '@/components/chat/dialog/consent/consent_onechat_dialog'
import Qrcodeuser from '@/components/mobile/dialog/QrcodeuserDialogMobile'
// import LeftSideMobile from '@/components/mobile/LeftSideMobile'
import Download from '@/components/mobile/dialog/DownloadAppMobile'
import AgoraCallDialog from '@/components/chat/agora_call/ans_call_v2'
import { sync } from 'vuex-pathify'
import { Decode, Encode } from '@/services'
import vue100vh from 'vue-100vh'
import newConsent from '@/components/consent/new_consent'

var Centrifuge = require('centrifuge')
var centrifuge = new Centrifuge(process.env.WEB_centrifuge)
// var _ = lodash()
export default {
  data: () => ({
    newConsentDialog: false,
    newConsentDetail: {},
    AgoraCallDialog: false,
    AgoraOption: '',
    infor_call: {},
    one_id: '',
    dilogDownload: true,
    show_alert: false,
    num_listalert: 0,
    list_alert: [],
    textsnackbar: '',
    snackbar: false,
    typeuser: '',
    room: '',
    profilepicture: '',
    name: '',
    token: '',
    business_id: '',
    status_login: '',
    business: [],
    citizen: {},
    listmenu: [{
        title: 'แก้ไขโปรไฟล์',
        icon: 'person',
        dialog: '/mobile/settings/profile'
      },
      {
        title: 'ส่งไฟล์ไป One box',
        icon: 'file_upload',
        dialog: '/mobile/settings/uploadfile/onebox'
      },
      {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        dialog: '/mobile/settings/feedback'
      },
      {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        dialog: '/mobile/settings/support'
      },
      {
        title: 'นโยบายความเป็นส่วนตัว',
        icon: 'book',
        dialog: '/mobile/settings/policy'
      }
    ],
    groupnameTest: '',
    windowWidth: '',
    dialogShowQRCode: false,
    consentOnechatDialog: false,
    url_consent: '',
  }),
  props: {
    source: String
  },
  methods: {
    closeNewConsent (value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
    },
    closeDialogConsentOnechat (value) {
      this.consentOnechatDialog = value
    },
    check_consent (token) {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)
      var expireddate = Date.parse(today)
      // console.log(expireddate)
      var body = Encode.encodeRichmenu({ 'userid': token, 'expired_date': expireddate })
      // console.log(body)
      this.progress = true
      // check new consent
      if (this.$cookie.get(`check-consent-${token}`) === null || this.$cookie.get(`check-consent-${token}`) === undefined) {
        // test new consent
        this.progress = false
        this.newConsentDialog = true
        this.newConsentDetail = {token: token}
      } else {
        this.progress = false
      }
      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'false') {
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    get_oneid () {
      this.axios.get(process.env.APIgo_api + `/v1/getOneID/${this.token}`).then((response) => {
        if (response.data.status === 'success') {
          this.one_id = response.data.one_id
        }
      })
    },
    decline_call (data) {
      console.log(data)
    },
    closeAgoraDialog (value) {
      this.AgoraCallDialog = value
    },
    dialog_alert (item) {
      this.show_alert = false
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: item.message,
        type: 'warning',
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง'
      })
    },
    getlistalert () {
      this.axios.post(process.env.APImanage + '/getlistannounce', {}).then((response) => {
        this.list_alert = response.data.list_announce
        this.num_listalert = this.lengthstateactive(this.list_alert)
        this.show_alert = true
        // if (this.num_listalert.length !== 0) {
        //   this.show_alert = true
        // } else {
        //   this.show_alert = true
        // }
        // console.log(response.data)
      })
    },
    lengthstateactive (list) {
      return _.filter(list, function (list) { return list.state === 'true' }).length
    },
    openQRcode() {
      this.dialogShowQRCode = true
    },
    closeShowQRCodeUser(value) {
      this.dialogShowQRCode = value
    },
    switchuser(item, name, type) {
      localStorage.setItem('profilepicture', item['profilepicture'])
      localStorage.setItem('name', name)
      localStorage.setItem('business_id', item['business_id'])
      localStorage.setItem('usertype', type)
      this.myprofilepicture = item['profilepicture']
      this.myname = name
      this.mybusiness_id = item['business_id']
      this.business_id = item['business_id']
      this.typeuser = type
    },
    toPage(page) {
      this.$router.push(page)
    },
    clickservice() {
      window.open('/homepage#oneplatform', '_blank')
    },
    logout() {
      this.$cookie.delete("tokenuser")
      this.$cookie.delete("status_login")
      localStorage.clear()
      // this.$router.push({
      //   path: '/login',
      //   force: true
      // })
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
      var logouturl = this.$cookie.get('logouturl')
      if (process.env.LogoutOneid) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          window.open(process.env.LogoutOneid, '_parent')
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          this.$router.push({path: '/login', force: true})
        }
      }
    },
    noti_msg(name, notimsg, room, pic, type) {
      if (pic === '') {
        if (type === 'company') {
          pic = '/static/img/default_profile/business-white.png'
        } else if (type === 'bot') {
          pic = '/static/img/default_profile/bot-white.png'
        } else if (type === 'government') {
          pic = '/static/img/default_profile/business-white.png'
        } else {
          pic = '/static/img/default_profile/man-white.png'
        }
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification('New message from ' + name, {
          body: notimsg,
          icon: pic,
          silent: true
        })
        notification.onclick = function() {
          window.open('/mobile/room/' + room, '_parent').focus()
        }
      } else {
        Notification.requestPermission().then(function(result) {
          // console.log(result)
        })
      }
    },
    other_noti(title, notimsg, pic) {
      if (pic === '') {
        pic = '/static/img/default_profile/man-white.png'
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, {
          body: notimsg,
          icon: pic,
          silent: true
        })
        notification.onclick = function() {}
      } else {
        Notification.requestPermission().then(function(result) {
          // console.log(result)
        })
      }
    },
    open(typecall, tokenroom) {
      // console.log(detailroom)
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // window.open('/video_call/answer/' + typecall + '/' + tokenroom, '_parent').focus()
      this.$router.push({
        path: '/video_callmo/answer/' + typecall + '/' + tokenroom,
        force: true
      })
    }
  },
  components: {
    // LeftSideMobile
    Qrcodeuser,
    vue100vh,
    Download,
    AgoraCallDialog,
    checkconsentOnechatDialog,
    newConsent
  },
  computed: {
    ...sync('*')
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    myprofilepicture() {
      this.profilepicture = localStorage.getItem('profilepicture')
    },
    myname() {
      this.name = localStorage.getItem('name')
      // console.log(this.name)
    },
    windowWidth() {
      // console.log(this.windowWidth)
      if (this.windowWidth > 960) {
        if (window.location.pathname === '/mobile/settings/profile') {
          this.$router.push('/chat/settings/profile')
        } else if (window.location.pathname === '/mobile/settings/uploadfile/onebox') {
          this.$router.push('/chat/settings/uploadfile/onebox')
        } else if (window.location.pathname === '/mobile/settings/feedback') {
          this.$router.push('/chat/settings/feedback')
        } else if (window.location.pathname === '/mobile/settings/support') {
          this.$router.push('/chat/settings/support')
        } else if (window.location.pathname === '/mobile/settings/policy') {
          this.$router.push('/chat/settings/policy')
        } else if (window.location.pathname === '/mobile/settings/managefriend') {
          this.$router.push('/chat/settings/managefriend')
        } else if (window.location.pathname === '/mobile/room/' + this.$route.params.roomid) {
          this.$router.push('/chat/room/' + this.$route.params.roomid)
        } else {
          this.$router.push('/chat')
        }
      }
    }
  },
  sockets: {
    connect() {
      console.log('socket connected')
      this.$socket.emit('join', {
        room: this.token,
        type: 'web'
      })
      this.snackbar = true
      this.textsnackbar = 'server connected'
    },
    disconnect: function() {
      // console.log('disconnect')
      this.snackbar = true
      this.textsnackbar = 'server disconnected'
    },
    // message(data) {
    //   console.log('socket message mobile')
    //   // console.log(data)
    //   if (data.hasOwnProperty('tokenuser')) {
    //     this.axios.post(process.env.APIalpine + '/api/v3/getmessage', {
    //       tokenmessage: data.tokenmessage,
    //       tokenuser: this.token
    //     }).then((response) => {
    //       this.socketmessage = response.data.source
    //       // console.log(this.socketmessage)
    //       if (data.tokenroom !== this.$route.params.roomid && data.tokenuser !== this.token) {
    //         if (response.data.source.typeofmessage !== 'message') {
    //           // this.noti_msg(response.data.source.nickname, 'Send:  ' + response.data.source.typeofmessage + ' to you', response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         } else {
    //           // this.noti_msg(response.data.source.nickname, 'Message:  ' + response.data.source.message, response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         }
    //       }
    //     })
    //   }
    // },
    announce_room (data) {
      this.socket_announce = data
    },
    event_unsend(data) {
      // console.log('event_unsend')
      this.socket_unsendmessage = data
    },
    // quick_reply(data) {
    //   // console.log(data)
    //   // console.log('quick_reply')
    //   this.socketquickreply = data
    // },
    // disable_quick_reply(data) {
    //   // console.log(data)
    //   // console.log('disable_quick_reply')
    //   this.socketdisablequickreply = data
    // },
    // disable_approve(data) {
    //   // console.log('disable_approve')
    //   this.socketdisableapprove = data
    // },
    event_note(data) {
      // console.log('event_note')
      if (data.tokenroom !== this.$route.params.roomid && data.owner !== this.token) {
        this.axios.post(process.env.APImanage + '/getuser', {
          owner: this.token,
          tokenuser: data.owner
        }).then((response) => {
          // this.noti_msg(response.data.source.nickname, 'Note:  ' + data.note_info.text, response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
        })
      } else {
        this.socketnote = data
      }
    },
    event_block(data) {
      // console.log('event_block')
      if (data.hasOwnProperty('tokenuser')) {
        this.socketblock = data
      }
    },
    event_friend(data) {
      // console.log(data)
      // console.log('event_friend')
      // this.name = data.tokenfriend[0]
      this.socketfriend = data
      if (data.konAdd !== this.token) {
        this.axios.post(process.env.APImanage + '/getuser', {
          owner: this.token,
          tokenuser: data.tokenfriend
        }).then((response) => {
          // console.log(response.data)
          if (response.data['user'][0]['type'] !== 'business') {
            // this.other_noti('Friend Request', 'Request friend from ' + response.data['user'][0]['name'], response.data['user'][0]['profilepicture'])
          }
        })
      }
    },
    event_accept_friend(data) {
      // console.log('event_accept_friend')
      this.socketaccept_friend = data
      this.axios.post(process.env.APImanage + '/getuser', {
        owner: this.token,
        tokenuser: [data.tokenfriend]
      }).then((response) => {
        if (response.data['user'][0]['type'] !== 'business') {
          // this.other_noti('Accept Friend', 'You and ' + response.data['user'][0]['name'] + ' are friend.', response.data['user'][0]['profilepicture'])
        }
      })
    },
    event_remove_request_friend(data) {
      // console.log('event_remove_request_friend')
      this.socketremove_request_friend = data
    },
    event_remove_friend(data) {
      // console.log('event_remove_friend')
      this.socketremove_friend = data
    },
    event_create_group(data) {
      // console.log('event_create_group')
      this.socketcreate_group = data
      if (data.fromtokenuser !== this.token) {
        this.axios.post(process.env.APImanage + '/getgroup', {
          group_id: data.groupid,
          tokenuser: data.fromtokenuser
        }).then((response) => {
          // console.log(response.data)
          this.groupnameTest = response.data.group.name
          this.axios.post(process.env.APImanage + '/getuser', {
            owner: this.token,
            tokenuser: [data.fromtokenuser]
          }).then((responsed) => {
            // console.log(responsed.data)
            // this.other_noti('Create group', 'Invite group', responsed.data['user'][0]['name'] + ' invite you to group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
          })
        })
      }
    },
    event_invite_group(data) {
      // console.log('event_invite_group: mobile')
      // console.log(data)
      this.socketinvite_group = data
      // console.log(this.socketinvite_group)
      if (data.userinvited !== this.token) {
        this.axios.post(process.env.APImanage + '/getgroup', {
          group_id: data.groupid,
          tokenuser: data.userinvited
        }).then((response) => {
          this.groupnameTest = response.data.group.name
          if (data.userinvited !== this.token) {
            this.axios.post(process.env.APImanage + '/getuser', {
              owner: this.token,
              tokenuser: [data.userinvited]
            }).then((responsed) => {
              // this.other_noti('Invite group', responsed.data['user'][0]['name'] + ' invite you to group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
            })
          }
        })
      }
    },
    event_active_group(data) {
      // console.log('event_active_group')
      this.socketactive_group = data
      if (data.tokenuser !== this.token) {
        this.axios.post(process.env.APImanage + '/getgroup', {
          group_id: data.groupid,
          tokenuser: this.token
        }).then((response) => {
          // console.log(response.data)
          this.groupnameTest = response.data.group.name
          this.axios.post(process.env.APImanage + '/getuser', {
            owner: this.token,
            tokenuser: [data.tokenuser]
          }).then((responsed) => {
            // this.other_noti('Accept group', responsed.data['user'][0]['name'] + ' accept group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
          })
        })
      }
    },
    event_cancel_group(data) {
      // console.log('event_cancel_group')
      this.socketcencel_group = data
    },
    event_leave_group(data) {
      // console.log('event_leave_group')
      this.socketleave_group = data
    },
    event_kick_group(data) {
      // console.log('event_kick_group')
      this.socket_kickmember = data
    },
    event_update_user(data) {
      // console.log('event_update_user')
      // console.log(data)
      if (data.tokenuser === this.token) {
        this.socketupdate_self = data
        if (data.type_update === 'status') {
          this.mystatus = data.update_data
          localStorage.setItem('status', data.update_data)
        } else if (data.type_update === 'pictureprofile') {
          this.myprofilepicture = data.update_data
          localStorage.setItem('profilepicture', data.update_data)
        } else if (data.type_update === 'name') {
          this.myname = data.update_data
          localStorage.setItem('name', data.update_data)
        }
      } else {
        this.socketupdate_friend = data
      }
    },
    signaling_message: function(data) {
      var me = this
      // console.log(data)
      var message = JSON.parse(data.message)
      // console.log('signaling_message')
      // if (data.type === 'SDP' && data.typesend === 'offer' && localStorage.getItem('Calling') !== 'true') {
      if (data.type === 'SDP' && data.typesend === 'offer') {
        if (message.sdp.type === 'offer' && data.name !== this.token) {
          // this.socketsignaling_message = data
          localStorage.setItem('stateCall', 'true')
          localStorage.setItem('socketsignaling_message', JSON.stringify(data))
          this.other_noti('มีสายเรียกเข้า', data.fullname + ' ต้องการสนทนากับคุณ', data.picture)
          this.open(data.typecall, data.room)
        }
      }
    },
    // disable_official_template (data) {
    //   this.socket_official_template = data
    // },
    // close_webview (data) {
    //   this.socket_close_webview = data
    // },
    // switch_keyboard (data) {
    //   console.log('switch_keyboard')
    //   // console.log(data)
    // },
    message_read (data) {
      // console.log('message read')
      // console.log(data)
    }
  },
  created() {
    // if (this.$cookie.get('status_login') !== 'T' || this.$cookie.get('status_login') === null) {
    // localStorage.setItem('pathRoom', this.$router.currentRoute.path)
    // this.$router.push('/login')
    // }
    this.business = JSON.parse(localStorage.getItem('business'))
    this.citizen = JSON.parse(localStorage.getItem('citizen'))
    this.room = this.$router.currentRoute.path
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.$socket.emit('connect')
    this.profilepicture = localStorage.getItem('profilepicture')
    this.name = localStorage.getItem('name')
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    // this.status_login = this.$cookie.get('status_login')
    this.typeuser = localStorage.getItem('type_user')
    this.business_id = localStorage.getItem('business_id')
    this.getlistalert()
    this.get_oneid()
    this.check_consent(this.token)
    var me = this
    var events = ''
    var data_msg = ''
    // centrifuge.setToken(process.env.centrifuge_key);
    centrifuge.setToken(process.env.centrifuge_key);
    centrifuge.subscribe(me.token, function(message) {
      // console.log(message)
      events = message.data.event
      data_msg = message.data.data
      // console.log(data_msg)
      console.log(`centrifuge mobile: ${events}`)
        if (events === 'message') {
          if (data_msg.last_tokenmessage !== undefined) {
            // event unsend
            me.socket_unsendmessage = data_msg
          } else {
            // ถ้าข้อความเป็น type official_template, system เก็ทข้อความแบบเดิม ส่วน type อื่นรับปกติ
            if (data_msg.typeofmessage === 'official_template' || data_msg.typeofmessage === 'system' || data_msg.typeofmessage === 'system_action_albums') {
              me.axios.post(process.env.APIalpine + '/api/v3/getmessage', {tokenmessage: data_msg.tokenmessage, tokenuser: me.token}).then((response) => {
                me.socketmessage = response.data.source
              })
            } else {
              // event message
              me.socketmessage = data_msg
            }
            // console.log(me.socketmessage)
            // if (data_msg.option !== undefined) {
            //     me.typeAgoraCall = data_msg.option
            // }
          }
          if (me.socketmessage.tokenroom !== me.$route.params.roomid && me.socketmessage.tokenuser !== me.token) {
            if (me.socketmessage.typeofmessage !== 'message') {
              me.noti_msg(me.socketmessage.nickname, 'Send:  ' + me.socketmessage.typeofmessage + ' to you', me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type)
            } else {
              // can't use this.convertMention
              me.noti_msg(me.socketmessage.nickname, 'Message:  '  + ((me.socketmessage.message).replace(/\<tax>/g,'@')).replace(/<\/tax>/g,''), me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type)
            }
          }
        } else if (events === 'disable_quick_reply') {
          me.socketdisablequickreply = data_msg
        } else if (events === 'update-agora') {
          me.socket_update_agora = data_msg
        } else if (events === 'accept_call') {
          me.socket_accept_call = data_msg
        } else if (events === 'service_call_agora') {
          // keep type option agora call
          if (process.env.NODE_ENV === 'development') {
            // ถ้ายังไม่ได้กดเข้าห้องแชทแต่มันการ call
            // if (me.$router.currentRoute.path === '/mobile/homepage') {
              // call agora
              setTimeout(function() {
                var infor = {
                  agora_token: data_msg.agora_token,
                  channel: data_msg.channel,
                  nickname: data_msg.nickname,
                  option: data_msg.option,
                  picture: data_msg.picture,
                  tokenroom: data_msg.tokenroom,
                  one_id: me.one_id
                }
                me.infor_call = infor
                me.AgoraOption = data_msg.option
                me.AgoraCallDialog = true
                // console.log(me.AgoraCallDialog)
                // console.log(me.infor_call)
              }, 1000);
            // } else {
              // me.typeAgoraCall = data_msg
            // }
            // console.log(me.typeAgoraCall)
          }
        } else if (events === 'message_read') {
          // console.log('message_read')
        } else if (events === 'disable_approve') {
          me.socketdisableapprove = data_msg
        } else if (events === 'quick_reply') {
          me.socketquickreply = data_msg
        } else if (events === 'close_webview') {
          me.socket_close_webview = data_msg
        } else if (events === 'switch_keyboard') {
          me.socket_switch_keyboard = data_msg
        } else if (events === 'switch_richmenu') {
          me.socket_switch_richmenu = data_msg
        } else if (events === 'disable_official_template') {
          me.socket_official_template = data_msg
        } else if (events === 'drop_menu') {
          me.socket_drop_menu = data_msg
        } else if (events === 'consent') {
          // me.consentOnechatDialog = false
          me.centrifuge_consent = data_msg
        }
    });

    centrifuge.on('connect', function() {
        console.log("connected mobile");
    });
    centrifuge.on('disconnect', function() {
        console.log("disconnected mobile");
    });
    centrifuge.connect();

  }
}
</script>
<style type="text/css" scoped>
/* >>>.v-menu__content .theme--light .menuable__content__active {
  max-width: 155px !important;
  top: 45px !important;
  left: 160px !important;
  transform-origin: left top !important;
  z-index: 8 !important;
} */
/* >>>.v-list .theme--light {
  width: 100% !important;
} */
/* >>>.v-menu__content {
  width: 140px !important;
  position: absolute;
  display: inline-block;
  border-radius: 2px;
  max-width: 80%;
  overflow-y: auto;
  overflow-x: hidden;
  contain: content;
  will-change: transform;
  box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
} */
>>>.swal2-popup #swal2-content {
  text-align: left !important;
}
.text-span {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
}
.text-span-dis {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  color: #aeb5bb;
}
>>>.v-badge--overlap .v-badge__badge {
  top: 14px !important;
  right: 12px !important;
}
/* >>>.theme--light.v-icon {
  color: rgb(37, 98, 175);
} */
b {
  font-weight: 900 !important;

}

.tabss {
  background-color: #1da1f2 !important;
}

.tabs__bar .icon--right {
  right: 10px !important;
}

.tabs__bar .icon--left {
  left: 10px !important;
}

.tabs:not(.tabs--grow):not(.tabs--mobile) .tabs__item {
  padding: 0 15px !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.text {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}

.textlayout {
  white-space: nowrap;
  width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 2vw;
  font-family: 'CS ChatThaiUI' !important;
  font-size: 18px;
  padding-bottom: 0px;
  color: white;
  text-transform: none;
}

span.badge__bage.red {
  left: 27px;
}

.icon {
  font-size: 25px !important;
}

.badge--overlap .badge__badge {
  top: -12px;
  right: -9px;
}

.application .theme--light.list .list__tile:not(.list__tile--active),
.theme--light .list .list__tile:not(.list__tile--active) {
  padding: 0 !important;
}

/*.application .theme--light.list, .theme--light .list {
  padding: 2vw !important;
}*/
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.listmenuweb {
  padding-left: 8px !important;
}

.list {
  padding-left: 8px !important;
}

>>>.v-expansion-panel__header {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/layout/LayoutMobile.vue